<template>
  <div class="index">
    <!-- 导航栏 -->
    <nav-header></nav-header>

    <!-- banner st -->
    <div class="banner">
      <img src="/imgs/banner2.jpg" alt="" />
    </div>
    <!-- banner end -->

    <!-- 第一屏 推荐动漫 st -->
    <div class="container">
      <!-- 推荐动漫 st -->
      <div class="cm1">
        <!-- 标题 -->
        <div class="cm1__title">
          <h2>Case show</h2>
          <p><i></i> <span>推荐动漫</span> <i></i></p>
        </div>
        <!-- 容器 -->
        <div class="cm1__con">
          <!-- 循环项 -->
          <div class="cm1__con__item" v-for="(item, index) in cm1" :key="index" @click="goDetails(item.id)">
            <!-- 图片区块 -->
            <div class="cm1__con__item__img">
              <img :src="item.img" alt="" />
              <!-- 蒙层 -->
              <div class="mask">
                <i class="iconfont icon-tuijian1"></i>
              </div>
            </div>
            <!-- 名称 -->
            <p>{{ item.name }}</p>
          </div>
        </div>

        <!-- 更多按钮 -->
        <a href="/#/ac1" class="cm1__button">MORE</a>
      </div>
      <!-- 推荐动漫 end -->
    </div>
    <!-- 第一屏 推荐动漫 end -->

    <!-- 关于我们 st -->
    <div class="us">
      <div class="container">
        <!-- 标题 -->
        <div class="us__title">
          <h2>About us</h2>
          <p><i></i> <span>关于我们</span> <i></i></p>
        </div>

        <!-- 容器 -->
        <div class="us__con">
          <div class="l">
            <div class="top">
              <h3>Jinjiang Wonderland</h3>
              <h4>北京晋江奇境网络科技有限公司</h4>
              <p>
                北京晋江奇境网络科技有限公司成立于2013年10月29日，注册地位于北京市密云区经济开发区西统路8号西田各庄镇政府办公楼508室—369，经营范围包括技术推广、技术开发、技术转让、技术咨询、技术服务；软件开发；从事互联网文化活动。（市场主体依法自主选择经营项目，开展经营活动；从事互联网文化活动以及依法须经批准的项目，经相关部门批准后依批准的内容开展经营活动；不得从事国家和本市产业政策禁止和限制类项目的经营活动。）。
              </p>
            </div>
            <div class="bottom">
              <a href="/infoList.html">付费资讯</a>
              <a href="/#/xy2">联系我们</a>
              <a href="/#/info2">加入我们</a>
              <a href="/#/xy4">自审制度</a>
            </div>
          </div>
          <div class="r">
            <img src="/imgs/us.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 关于我们 end -->

    <!-- 动漫资讯 st -->
    <div class="info">
      <div class="container">
        <!-- 标题 -->
        <div class="info__title">
          <h2>Animation information</h2>
          <p><i></i> <span>动漫资讯</span> <i></i></p>
        </div>

        <!-- 容器 -->
        <div class="info__con">
          <div class="l">
            <img src="/imgs/1.jpg" alt="" />
          </div>
          <div class="r">
            <!-- 循环项 -->
            <div class="item" v-for="(item, index) in this.mz" :key="index" @click="goDetails2(item.id)">
              <div class="item-l">
                <h3>0{{ item.id }}</h3>
                <p>{{ item.time }}</p>
              </div>
              <div class="item-r">
                <h4>{{ item.title }}</h4>
                <p>
                  {{ item.p1 }}
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- 动漫资讯 end -->

    <!-- 动漫展示 st -->
    <div class="cm2">
      <div class="container">
        <!-- 标题 -->
        <div class="cm2__title">
          <h2>Animation display</h2>
          <p><i></i> <span>动漫展示</span> <i></i></p>
        </div>

        <!-- 容器 -->
        <div class="con">
          <!-- 容器列表 -->
          <div class="con-list" v-for="(item, index) in cm2" :key="index" >
            <div class="l">
              <img :src="item.img" alt="" />
              <h4>{{ item.name }}</h4>
              <a href="javascript:;" class="l-btn" @click="goDetails(item.id)">观看全部</a>
            </div>
            <div class="r">
              <!-- 图片循环项 -->
              <div class="r-item" v-for="j  in item.imgList" :key="j">
                <img :src="j" alt="" />
              </div>
            </div>
          </div>
        
        </div>

        <!-- 更多按钮 -->
        <a href="/#/ac1" class="cm2__button">MORE</a>
      </div>
    </div>
    <!-- 动漫展示 end -->
  </div>
</template>

<script>

import NavHeader from "./../components/NavHeader";
export default {
  name: "index",
  data() {
    return {
      listac: "home",
      state: JSON.parse(window.localStorage.getItem("state")),
      logo_user: JSON.parse(window.localStorage.getItem("user")),
      href: "/",
      // 推荐动漫 数据
      cm1: [],
      cm2: [],
      // 资讯数据
      mz: [],
    };
  },
  components: {
    NavHeader,

  },
  mounted() {
    this.init();
    document.title = "晋江奇境 ";
  },
  methods: {
    // 真实支付逻辑
    alipay(data, index, price) {
      console.log(data);
      var payAmount = price; //支付价格
      var orderName = "动漫支付下载"; //订单名称
      var id = index; //订单名称
      var userName = this.logo_user.username;

      if (this.state == 0) {
        window.open(
          "http://www.jjqj.net/alipay/index.php?payAmount=" +
          payAmount +
          "&orderName=" +
          orderName +
          "&id=" +
          id +
          "&userName=" +
          userName
        );
        return;
      }
      // 未登录
      if (this.state !== 0) {
        alert("点击登录去付款下载~");
        this.$router.push({ path: "/login", query: { k: 1 } });
        return;
      }
    },

    // 渲染数据
    init() {

      // 推荐动漫 
      this.axios.get("/mock/a.json").then((res) => {
        var data = res.data;
        this.cm1 = data;
      });

      this.axios.get("/mock/LS_annotations.json").then((res) => {
        var data = res.data;
       console.log(data)
      });

      // 动漫资讯
      this.axios.get("/mock/index1.json").then((res) => {
        const data = res.data;
        this.mz = data.slice(0, 4);

      });

      // 动漫展示
      this.axios.get("/mock/list.json").then((res) => {
        var data = res.data;
        this.cm2 = data.slice(0, 3);
      });


    },
    // 跳转 逻辑 封装
    goDays(methods, item, index, type) {
      this[methods](item, index, type);
    },
    // 动漫跳转
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
    // 文章跳转
    goDetails2(id) {
      this.$router.push({
        path: "/sound2/:" + id,
        query: { type: id },
      });
    },
    // 文章跳转
    goDetails3(id) {
      this.$router.push({
        path: "/sound3/:" + id,
        query: { type: id },
      });
    },
    // 收费逻辑
    gopay() {
      console.log(this.state);
      if (this.state == 0) {
        this.$router.push("/pay");
        return;
      }
      // 未登录
      if (this.state !== 0) {
        alert("点击登录去购买~");
        this.$router.push({ path: "/login", query: { k: 1 } });
        return;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
@import url("http://www.jq22.com/jquery/bootstrap-3.3.4.css");

.index {

  // background: #f5f5f5;
  // banner
  .banner {
    width: 100%;
    height: 400px;
    margin-bottom: 30px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  // 第一屏 推荐动漫
  .container {

    // 推荐动漫
    .cm1 {
      margin: 25px 0;

      // 标题
      &__title {
        text-align: center;

        h2 {
          font-size: 33px;
          line-height: 46.2px;
          color: #e3e3e0;
          font-weight: bold;
        }

        p {
          color: rgb(67, 67, 67);
          font-size: 24px;
          display: flex;
          align-items: center;
          justify-content: center;

          span {
            margin: 10px 15px;
          }

          i {
            width: 10px;
            height: 4px;
            background: #000;
            display: inline-block;
          }
        }
      }

      // 容器
      &__con {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        // 循环项
        &__item {
          width: 300px;
          height: 330px;
          margin: 15px;
          cursor: pointer;

          // 图片
          &__img {
            width: 300px;
            height: 300px;
            background: #000;
            position: relative;
            text-align: center;
            line-height: 300px;

            &:hover {
              .mask {
                height: 100%;
                opacity: 1;

                i {
                  font-size: 50px;
                  font-weight: bold;
                }
              }
            }

            // 蒙层
            .mask {
              width: 100%;
              height: 0;
              position: absolute;
              background-color: rgba(255, 255, 255, 0.8);
              top: 0;
              left: 0;
              transition: all 0.5s;
              opacity: 0;
              display: flex;
              align-items: center;
              justify-content: center;

              i {
                font-size: 35px;
                transition: all 0.7s;
                color: #4bc0bf;
              }
            }
          }

          p {
            text-align: center;
            font-size: 12px;
            line-height: 30px;
            font-weight: bold;
            color: #666;
          }
        }
      }

      // 更多按钮
      &__button {
        width: 312px;
        height: 54px;
        line-height: 54px;
        margin: 10px auto;
        background-color: #4bc0bf;
        color: #fff;
        text-align: center;
        cursor: pointer;
        font-size: 14px;
        display: block;
        text-decoration: none;
        transition: all 0.5s;

        &:hover {
          background-color: rgba(67, 67, 67, 1);
        }
      }
    }
  }

  // 关于我们
  .us {
    margin: 35px 0;
    padding: 15px 0;
    box-sizing: border-box;
    background: url("/imgs/us-banner.jpg") center;
    background-size: cover;

    // 标题
    &__title {
      text-align: center;

      h2 {
        font-size: 33px;
        line-height: 46.2px;
        color: #dbdbdb;
        font-weight: bold;
      }

      p {
        color: rgb(67, 67, 67);
        font-size: 24px;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          margin: 10px 15px;
        }

        i {
          width: 10px;
          height: 4px;
          background: #000;
          display: inline-block;
        }
      }
    }

    &__con {
      width: 100%;
      height: 400px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .l {
        width: 60%;
        height: 100%;
        margin-right: 20px;
        background-color: rgb(67, 67, 67);

        .top {
          width: 100%;
          height: 85%;
          background: #313131;
          padding: 20px 20px;
          box-sizing: border-box;

          h3 {
            color: rgb(95, 116, 109);
            font-size: 35px;
            font-weight: bold;
            letter-spacing: 8px;
            margin: 10px 0;
          }

          h4 {
            color: #ededed;
            font-size: 28px;
          }

          p {
            font-size: 14px;
            color: #ccc;
            line-height: 35px;
            margin-top: 20px;
          }
        }

        .bottom {
          width: 100%;
          height: 15%;
          background: #000;
          display: flex;
          align-items: center;
          justify-content: space-between;

          a {
            display: block;
            text-decoration: none;
            height: 100%;
            flex: 1;
            background: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #888;
            font-size: 14px;
            transition: all 0.3s;

            &:hover {
              background-color: #4bc0bf;
              color: #fff;
            }
          }
        }
      }

      .r {
        width: 40%;
        height: 100%;
        background-color: #ff6600;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  // 动漫资讯
  .info {
    margin: 40px 0;

    // 标题
    &__title {
      text-align: center;

      h2 {
        font-size: 33px;
        line-height: 46.2px;
        color: #e3e3e0;
        font-weight: bold;
      }

      p {
        color: rgb(67, 67, 67);
        font-size: 24px;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          margin: 10px 15px;
        }

        i {
          width: 10px;
          height: 4px;
          background: #000;
          display: inline-block;
        }
      }
    }

    // 容器
    .info__con {
      width: 100%;
      height: 455px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .l {
        width: 40%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 20px;

        img {
          width: 344px;
          height: 346px;
          background-color: #fff;
          border-radius: 50%;
        }
      }

      .r {
        width: 60%;
        height: 100%;

        // 循环项
        .item {
          width: 100%;
          height: 100px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;

          &:hover {
            .item-r {
              h4 {
                color: #4bc0bf;
              }
            }
          }
          // 左侧
          .item-l {
            width: 84px;
            height: 65px;
            background: #4bc0bf;
            color: #fff;
            text-align: center;
            padding: 5px 0;
            box-sizing: border-box;
            margin-right: 15px;

            h3 {
              font-size: 30px;
            }

            p {
              font-size: 12px;
              margin-top: 3px;
            }
          }

          // 右侧
          .item-r {
            width: 100%;
            height: 100%;
            line-height: 21px;
            h4 {
              font-size: 15px;
              color: #000;
              margin: 15px 0;
              cursor: pointer;
            }

            p {
              font-size: 12px;
              color: #c1c1c1;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
    }
  }

  // 动漫展示
  .cm2 {
    margin: 40px 0;

    // 标题
    &__title {
      text-align: center;

      h2 {
        font-size: 33px;
        line-height: 46.2px;
        color: #e3e3e0;
        font-weight: bold;
      }

      p {
        color: rgb(67, 67, 67);
        font-size: 24px;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          margin: 10px 15px;
        }

        i {
          width: 10px;
          height: 4px;
          background: #000;
          display: inline-block;
        }
      }
    }

    // 容器
    .con {
      width: 100%;

      // 容器列表
      .con-list {
        width: 100%;
        height: 300px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #ccc;
        margin: 35px 0;

        .l {
          width: 28%;
          height: 100%;
          text-align: center;
          border-right: 1px solid #ccc;

          img {
            width: 180px;
            height: 180px;
            background-color: #fff;
            margin: 25px 0;
          }

          h4 {
            font-size: 12px;
            font-weight: bold;
          }

          .l-btn {
            width: 130px;
            height: 35px;
            background: #4bc0bf;
            margin: 0 auto;
            margin-top: 10px;
            color: #fff;
            line-height: 35px;
            font-size: 12px;
            cursor: pointer;
            display: block;
            text-decoration: none;
            transition: all 0.5s;

            &:hover {
              background-color: rgba(67, 67, 67, 1);
            }
          }
        }

        .r {
          width: 70%;
          height: 100%;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;

          .r-item {
            width: 120px;
            height: 120px;
            margin: 15px;
            cursor: pointer;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    // 更多按钮
    .cm2__button {
      width: 312px;
      height: 54px;
      line-height: 54px;
      margin: 10px auto;
      background-color: #4bc0bf;
      color: #fff;
      text-align: center;
      cursor: pointer;
      font-size: 14px;
      display: block;
      text-decoration: none;
      transition: all 0.5s;

      &:hover {
        background-color: rgba(67, 67, 67, 1);
      }
    }
  }
}
</style>
